<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Ajout d'un motif d'appel</h1>
                <div class="pageOptions">
                    <btn text="Enregistrer" ico="valide" @click="save" v-if="$store.getters.hasPerm('reason:add/edit')"></btn>
                    <btn ico="times" color="red" @click="cancel" v-if="$store.getters.hasPerm('reason:add/edit')"></btn>
                </div>
            </div>
        </div>
        <form>
            <div class="large mb">
                <label for="label">Libelle du motif</label>
                <input type="text" v-model="reason.label" id="label">
            </div>
            <div class="large mb">
                <label for="Observation">Observation</label>
                <textarea v-model="reason.observation" rows="4" id="Observation"></textarea>
            </div>
            <div class="line mb">
                <div class="checkbox">
                    <input type="checkbox" id="rdvObligatoire" v-model="call_meet_require">
                    <label for="rdvObligatoire" >Nombre de RDV obligatoire</label>
                </div>
                <div class="checkbox">
                    <input type="checkbox" id="observationObligatoire" v-model="observation_require">
                    <label for="observationObligatoire" >Observation obligatoire</label>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import Btn from "@/components/Btn";
    import Loader from "@/components/Loader";
    import axios from 'axios';
    import tools from '../config.ts';

    export default {
        name: "Reason",
        components: {Btn,Loader},
        data() {
            return {
                reason:{},
                reasonId:{},

                btnAjoute:"Ajoute",
            }
        },
        methods:{
            load(){

                if(!this.reasonId){

                    tools.loader(false);
                    return;
                }

                axios.get(tools.api("reason/"+this.reasonId),tools.headerGET())
                    .then((response) => {
                        this.reason = response.data;
                        tools.loader(false);
                    })
            },
            save(){
                let url = "reason";

                if(this.reasonId){
                    url += "/"+this.reasonId;
                }

                tools.loader(true);

                axios.post(tools.api(url),tools.toPOST({
                    id:this.reasonId,
                    label:this.reason.label,
                    observation:this.reason.observation,
                    call_meet_require:this.reason.call_meet_require || "0",
                    observation_require:this.reason.observation_require || "0",
                }),tools.headerPOST())
                    .then((response) => {
                        tools.loader(false);
                        if(!tools.isSuccessResponse(response)){
                            return tools.popup("valid",{
                                title : "Erreur",
                                message : "Erreur lors de l'enregistrement du motif d'appel",
                            });
                        }
                        this.$router.push("/reasons")
                    })
                    .catch((error) => {
                        tools.loader(false);
                        tools.popup("valid",{
                            title : "Erreur",
                            message : "Erreur lors de l'enregistrement du motif d'appel. <br/><br/>Détail de l'erreur : <br/>"+tools.parseError(error)
                        })
                    })
            },
            cancel(){
                tools.popup("confirm",{
                    title:"Confirmation",
                    message :"Voulez-vous vraiment annuler les modifications ?",
                    success : () => {
                        this.$router.push("/reasons");
                    }
                })
            }
        },
        computed:{
            call_meet_require:{
                set (call_meet_require)  {
                    this.reason.call_meet_require = call_meet_require ? "1" : "0";
                },
                get ()  {
                    return this.reason.call_meet_require === "1" ;
                }
            },
            observation_require:{
                set (observation_require)  {
                    this.reason.observation_require = observation_require ? "1" : "0";
                },
                get ()  {
                    return this.reason.observation_require === "1" ;
                }
            }
        },
        mounted(){

            if(!this.$store.getters.hasPerm('reason:add/edit')){
                return this.$router.back();
            }

            tools.loader(true);
            this.$store.commit("onEditMode",true);

            this.reasonId = this.$route.params.id;

            this.load();
        }
    }
</script>
